import { create } from "zustand";
import { persist } from "zustand/middleware";

interface MentorViewStore {
  mentorView: boolean;
  setMentorView: (value: boolean) => void;
}

export const useMentorView = create(
  persist<MentorViewStore>(
    (set) => ({
      mentorView: false,
      setMentorView: (value) => set({ mentorView: value }),
    }),
    {
      name: "mentor-view",
    },
  ),
);
